// src/components/Contact.jsx
import React, { useState } from 'react';
import { PRIMARY_FONT } from '../constants';
import ScribbleText from './ScribbleText';

const Contact = () => {
  const [formStatus, setFormStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);

    try {
      const response = await fetch('https://formspree.io/f/contact@fologan.com', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (response.ok) {
        setFormStatus('¡Gracias por tu mensaje! Te responderemos pronto.');
        e.target.reset();
      } else {
        setFormStatus('Hubo un problema al enviar el mensaje. Por favor, inténtalo de nuevo.');
      }
    } catch (error) {
      setFormStatus('Hubo un error al enviar el mensaje. Por favor, inténtalo de nuevo más tarde.');
    }
  };

  return (
    <div className="max-w-md mx-auto text-white notebook-card p-8 relative">
      <div className="smudge" style={{ top: '15px', right: '30px' }} />

      <h2
        className="font-handwritten text-4xl font-bold mb-1 tracking-tight"
        style={{ fontFamily: PRIMARY_FONT }}
      >
        <ScribbleText>Contacto</ScribbleText> Contact
      </h2>
      <p className="font-handwritten text-xs text-white text-opacity-20 mb-6" style={{ transform: 'rotate(-0.5deg)' }}>
        (escríbeme, no muerdo)
      </p>

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          required
          className="font-handwritten text-lg w-full p-3 rounded-sm bg-white bg-opacity-5 border border-white border-opacity-10 text-white placeholder-white placeholder-opacity-20 focus:outline-none focus:border-sky-400 focus:border-opacity-30 transition-colors"
        />
        <input
          type="email"
          name="email"
          placeholder="Your Email"
          required
          className="font-handwritten text-lg w-full p-3 rounded-sm bg-white bg-opacity-5 border border-white border-opacity-10 text-white placeholder-white placeholder-opacity-20 focus:outline-none focus:border-sky-400 focus:border-opacity-30 transition-colors"
        />
        <textarea
          name="message"
          placeholder="Your Message"
          required
          className="font-handwritten text-lg w-full p-3 rounded-sm bg-white bg-opacity-5 border border-white border-opacity-10 text-white placeholder-white placeholder-opacity-20 focus:outline-none focus:border-sky-400 focus:border-opacity-30 transition-colors"
          rows={4}
        ></textarea>
        <button
          type="submit"
          className="font-handwritten text-lg text-sky-300 border border-sky-400 border-opacity-30 px-6 py-2 rounded-sm hover:bg-sky-400 hover:bg-opacity-10 transition-all duration-300"
        >
          Send
        </button>
      </form>
      {formStatus && (
        <p className="mt-4 text-center font-handwritten text-lg text-sky-300 text-opacity-70">{formStatus}</p>
      )}
    </div>
  );
};

export default Contact;
